module.exports = __webpack_public_path__ + "img/blog-hover.cc68ed7e.svg";